export enum QualificationType {
  CompleteQualification = 1,
  PartialQualification = 2,
  MicroQualification = 4,
}